import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="49" viewbox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.404 17.644c-5.089 3.802-4.383 11.75-1.38 14.146-.518 1.562-.241 3.035.157 4.294-4.762-3.462-7.763-9.981-7.579-12.774.598.69 1.404 1.005 2.232.745-8.653-6.015-8.553-14.27-7.94-17.737 2.21 6.199 11.063 10.016 14.51 11.326Zm13.967 7.765a7.242 7.242 0 1 1-14.484 0 7.242 7.242 0 0 1 14.484 0Zm.74 6.381c3.002-2.396 3.708-10.344-1.381-14.146 3.447-1.31 12.3-5.127 14.51-11.326.613 3.468.713 11.722-7.94 17.737.828.26 1.633-.054 2.232-.744.184 2.792-2.817 9.311-7.58 12.773.4-1.259.675-2.732.159-4.294Z" fill="#80989D"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
